<form *ngIf="form" [formGroup]="form" #myForm="ngForm" class="flex h-full flex-col gap-8 py-4">
  <ng-container *ngIf="!showEmptyState()" class="" [formArrayName]="FormControlName.blocks">
    <h5 [innerHTML]="breadcrumbs()" class="uppercase text-pl-orange-800"></h5>
    <ng-container *ngFor="let block of formArrayBlocks.controls; let index = index">
      <ng-container [ngSwitch]="block.value.element">
        <pl-block-button *ngSwitchCase="BlockType.button" [formControlName]="index + ''" />

        <pl-block-lifeact
          *ngSwitchCase="BlockType.lifeAct"
          [formControlName]="index + ''"
          [timeFormat]="participantTimeFormat()"
        />
      </ng-container>
    </ng-container>
  </ng-container>

  <div class="flex grow justify-center items-center" *ngIf="showEmptyState()">
    <p class="text-center text-lg font-bold">
      {{ 'profile.weekly_lifeacts.select_lifeact' | translate }}
    </p>
  </div>
</form>
